import React, { useState } from 'react';

import { Container, Grid, makeStyles } from '@material-ui/core';

import { useProviderSearch } from '../../../hooks/useProviderSearch';
import { FuneralHome } from '../../../static/models/FuneralHome';
import Settings from '../../../static/models/Settings';
import pullQueryParam from '../../../toolboxes/reusable-logic/pull-query-param';
import ProviderList from '../../global-components/provider-list/ProviderList';
import ProviderMap from '../../global-components/provider-map/ProviderMap';
import Search from '../../global-components/search/Search';

export const REFERRAL_ACCOUNT_IDENTIFIER_PARAM_KEY = 'refAccountID';
const SEARCH_PARAM_KEY = 'search';

export interface ProviderSearchPageProps {
    settings: Settings;
}

const useStyles = makeStyles((theme) => ({
    accountList: {
        overflow: 'auto',
        [theme.breakpoints.up('md')]: {
            maxHeight: '70vh',
        },
        [theme.breakpoints.down('sm')]: {
            maxHeight: '67vh',
        },
        '&::-webkit-scrollbar': {
            width: '0.4em'
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
            webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.5)',
            outline: `1px solid slategrey`
        }
    },
}));

const ProviderSearchPage: React.FunctionComponent<ProviderSearchPageProps> = ({
    settings,
}: ProviderSearchPageProps) => {
    const classes = useStyles();
    const initialSearch = pullQueryParam(SEARCH_PARAM_KEY, window.location.href) || '';
    const referralAccountIdentifier = pullQueryParam(REFERRAL_ACCOUNT_IDENTIFIER_PARAM_KEY, window.location.href) || '';
    const [searchQuery, setSearchQuery] = useState(initialSearch);
    const { isLoading, locations, searchLocation } = useProviderSearch(searchQuery, settings);
    const [selectedLocation, setSelectedLocation] = useState<FuneralHome>();

    const onLocationSelect = (location: FuneralHome | undefined) => {
        setSelectedLocation(location);
    };

    return (
        <Container>
            <Grid container spacing={5}>
                <Grid item sm={6}>
                    <Grid container direction="column" spacing={2}>
                        <Grid item>
                                <Search
                                    isLoading={isLoading}
                                    onSearch={value => setSearchQuery(value)}
                                    initialSearch={searchQuery}
                                />
                        </Grid>
                        <Grid item className={classes.accountList}>
                            <ProviderList
                                isLoading={isLoading}
                                locations={locations}
                                searchLocation={searchLocation}
                                settings={settings}
                                referralAccountIdentifier={referralAccountIdentifier}
                                selectedLocation={selectedLocation}
                                setSelectedLocation={onLocationSelect}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item sm={6} >
                    <ProviderMap
                        isLoading={isLoading}
                        locations={locations}
                        searchLocation={searchLocation}
                        googleMapsApiKey={settings.googleMapsApiKey}
                        selectedLocation={selectedLocation}
                        setSelectedLocation={onLocationSelect}
                    />
                </Grid>
            </Grid>
        </Container>
    );
};

export default ProviderSearchPage;
